enum ActionTypes {
  CLOSE_USER_PROFILE_CARD = "app/userProfileCard/CLOSE_USER_PROFILE_CARD",
  OPEN_USER_PROFILE_CARD = "app/userProfileCard/OPEN_USER_PROFILE_CARD",
  RESET = "app/userProfileCard/RESET",
}

export default ActionTypes;
